import { Component, ElementRef, signal, ViewChild, WritableSignal } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { FieldTypeConfig } from '@ngx-formly/core'
import { FieldType } from '@ngx-formly/material'
import { selectOption } from 'src/types/wizard'

@Component({
	selector: 'gwc-autocomplete',
	templateUrl: './autocomplete.component.html',
	styleUrls: ['./autocomplete.component.scss'],
	imports: [
		FormsModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule
	]
})

export class AutocompleteComponent extends FieldType<FieldTypeConfig> {
	@ViewChild('autocomplete_input') input!: ElementRef<HTMLInputElement>

	public filteredOptions: WritableSignal<selectOption[]> = signal([])
	public filteredCommonlyUsed: WritableSignal<selectOption[]> = signal([])
	private select_options: WritableSignal<selectOption[]> = signal([])

	ngOnInit(): void {
		this.resetFilteredOptions()
	}

	public resetFilteredOptions() {
		const all_options = this.props.options as selectOption[] || []
		if (this.props['filter']) {
			this.select_options.set(all_options.filter(option => this.props['filter'].includes(option.value)))
		} else if (this.props['excludes']) {
			this.select_options.set(all_options.filter(option => !this.props['excludes'].includes(option.value)))
		} else {
			this.select_options.set(all_options)
		}

		this.filteredOptions.set(this.select_options())
		this.filteredCommonlyUsed.set(this.props['commonly_used'] || [])
	}

	public displayFunction = (value: string): string => {
		if (this.select_options) {
			const filtered = this.select_options().filter(options => options.value === value)

			return filtered[0]?.label || ''
		}

		return ''
	}

	public filterOptions(): void {
		if (this.input) {
			const filterValue = this.input.nativeElement.value.toLowerCase()
			this.filteredOptions.set(this.select_options().filter(option => option.label.toLowerCase().startsWith(filterValue)))

			if (this.props['commonly_used']) {
				if (filterValue) {
					this.filteredCommonlyUsed.set([])
				} else {
					this.filteredCommonlyUsed.set(this.props['commonly_used'])
				}
			}
		}
	}
}
